import React from 'react';
import { Link } from 'react-router-dom';

export default function RenovationGlobalePage() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero" style={{ background: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url('/assets/images/AdobeStock_259353430.jpeg') center/cover" }}>
        <div className="container" style={{ width: '100%' }}>
          <div className="hero-content">
            <h1 className="hero-title">Rénovation <span className="text-accent">Globale</span></h1>
            <p className="hero-subtitle">Transformez votre maison en un seul projet : panneaux solaires, pompe à chaleur et isolation. Bénéficiez d'aides exceptionnelles jusqu'à <strong>90% du coût des travaux</strong> et divisez vos factures énergétiques par 10.</p>
            <div className="hero-buttons" style={{ justifyContent: 'center', maxWidth: '400px', margin: '0 auto' }}>
              <Link to="/#contact" className="btn btn-primary" style={{ padding: '14px 28px', fontSize: '1rem' }}>Demander un devis gratuit</Link>
              <a href="tel:0465845177" className="phone-number" style={{ color: 'white', borderColor: 'white' }}>04 65 84 51 77</a>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="advantages-section">
        <div className="container">
          <div className="section-header">
            <h2>Pourquoi choisir la <span className="text-accent">rénovation globale</span> ?</h2>
            <p>La rénovation globale vous permet d'optimiser les performances et de maximiser les aides financières</p>
          </div>
          <div className="advantages-grid">
            {[
              { title: "Jusqu'à 90% d'aides", text: "Bénéficiez du maximum d'aides financières en combinant plusieurs travaux dans un seul projet." },
              { title: 'Maison autonome', text: "Atteignez l'autonomie énergétique avec une maison qui produit plus d'énergie qu'elle n'en consomme." },
              { title: 'Gain de temps', text: "Un seul interlocuteur, un seul chantier, une seule démarche administrative pour tous vos travaux." },
              { title: 'Valorisation maximale', text: "Augmentez significativement la valeur de votre bien avec un saut de plusieurs classes énergétiques." },
            ].map((a) => (
              <div className="advantage-card" key={a.title}>
                <div className="advantage-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                </div>
                <h3>{a.title}</h3>
                <p>{a.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packs */}
      <section className="products-section">
        <div className="container">
          <div className="section-header">
            <h2>Nos <span className="text-accent">packs rénovation</span></h2>
            <p>Des solutions complètes adaptées à votre budget et vos objectifs énergétiques</p>
          </div>
          <div className="products-grid">
            {[
              {
                title: 'Pack Confort',
                priceB: '25 000€',
                priceA: 'À partir de 5 000€*',
                note: '*Après aides financières',
                items: ['Isolation des combles', 'Pompe à chaleur air-air', 'Régulation intelligente'],
                badge: null,
              },
              {
                title: 'Pack Autonomie',
                priceB: '45 000€',
                priceA: 'À partir de 4 500€*',
                note: '*Après aides financières',
                items: ['Panneaux photovoltaïques 8 kWc', 'Pompe à chaleur air-eau', 'Isolation thermique extérieure', 'Batterie de stockage'],
                badge: 'Le plus populaire',
              },
              {
                title: 'Pack Excellence',
                priceB: '65 000€',
                priceA: 'À partir de 6 500€*',
                note: '*Après aides financières',
                items: ['Panneaux photovoltaïques 12 kWc', 'PAC air-eau haute performance', 'Isolation extérieure complète', 'Batterie 15 kWh', 'Borne de recharge VE'],
                badge: null,
              },
            ].map((p) => (
              <div className={`product-card ${p.badge ? 'featured' : ''}`} key={p.title} style={{ padding: '30px' }}>
                {p.badge && <div className="product-badge">{p.badge}</div>}
                <h3 style={{ fontSize: '1.4rem', marginBottom: '20px' }}>{p.title}</h3>
                <div className="pack-price">
                  <span className="price-before">{p.priceB}</span>
                  <span className="price-after">{p.priceA}</span>
                  <span className="price-note">{p.note}</span>
                </div>
                <ul className="pack-list">
                  {p.items.map((item) => (
                    <li key={item}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/#contact" className="btn btn-primary" style={{ display: 'block', textAlign: 'center', marginTop: '20px' }}>Demander ce pack</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Aids */}
      <section className="financial-aids">
        <div className="container">
          <div className="section-header">
            <h2>Les aides pour votre <span className="text-accent">rénovation globale</span></h2>
          </div>
          <div className="aids-grid">
            {[
              { title: "Ma Prime Rénov' Parcours Global", text: "Pour les rénovations d'ampleur, l'État a créé un parcours spécifique avec des aides renforcées pouvant couvrir jusqu'à 70% des travaux." },
              { title: 'Certificats d\'Économies d\'Énergie', text: "En combinant plusieurs travaux, vous maximisez les CEE. Un accompagnateur rénov' est obligatoire pour les travaux dépassant 5 000€." },
              { title: 'Éco-PTZ', text: "L'éco-prêt à taux zéro vous permet d'emprunter jusqu'à 50 000€ sans intérêts pour financer vos travaux de rénovation énergétique." },
              { title: 'TVA à 5,5%', text: "Tous les travaux de rénovation énergétique bénéficient d'une TVA réduite à 5,5%, soit une économie de 14,5 points par rapport au taux normal." },
            ].map((a) => (
              <div className="aid-card" key={a.title}><h3>{a.title}</h3><p>{a.text}</p></div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Rénovez votre maison en une seule fois !</h2>
          <p>Nos experts vous accompagnent de A à Z pour maximiser vos économies</p>
          <div className="cta-buttons">
            <Link to="/#contact" className="btn btn-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Demander mon bilan énergétique gratuit</Link>
            <a href="tel:0465845177" className="btn-outline-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Appeler le 04 65 84 51 77</a>
          </div>
        </div>
      </section>
    </>
  );
}
